module.exports = __webpack_public_path__ + "img/72maegami.15461e95.png";